@if (loading()) {
	<nz-spin nzSimple nzSize="small"></nz-spin>
} @else {
	@if (location(); as location) {
		<div class="horizontal">
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR"
				[nz-tooltip]="'Existing school admins in the location.'"
			>
				<nz-icon nzType="user"></nz-icon>
				{{ existingSchoolAdmins() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR"
				[nz-tooltip]="'How many new school admins will be assigned to this location.'"
			>
				<nz-icon nzType="user"></nz-icon>
				{{ addedSchoolAdmins() }}
			</nz-tag>
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_REMOVED_COLOR"
				[nz-tooltip]="'How many school admins will be unassigned from this location.'"
			>
				<nz-icon nzType="user"></nz-icon>
				{{ removedSchoolAdmins() }}
			</nz-tag>
		</div>

		@if (enableEditButton()) {
			<button
				nz-button
				nzType="primary"
				nzSize="small"
				(click)="editLocation(location)"
				nzShape="circle"
				nz-tooltip="Edit the location and users"
			>
				<nz-icon nzType="edit" />
			</button>
		}
	}
}
